import { CXoneEvent } from './cxone-event';
/**
 * This is base class event for other events
 */
export abstract class CXoneAgentEvent extends CXoneEvent {
    /**
     * @remarks -
     */
    iisHost!: string;

    /**
     * @remarks -
     */
    vcHost!: string;

    /**
    * This method to parse event data
    * @param event - event data 
    */
    protected abstract parse(event: { [key: string]: string }): void;
}



